import React, { Component } from 'react';
import Toolbar from 'components/Toolbar';
import Button from 'components/Button';

export default class MediaTools extends Component {

	render() {
		const {
			mediaareaRows,

			onUp,
			onDown,
			onTop,
			onBottom,
			onBatchEdit,
			onDelete,
			onClear,
		} = this.props;
		return (
			<Toolbar>
				<Button.Group>
					<Button icon="up"
						tooltip={window.language['playlist.mediaarea.tipup']}
						disabled={mediaareaRows.length < 1}
						onClick={(event) => {
							onUp(event, 'mediaArea', { type: 'up' });
						}}>
					</Button>
					<Button icon="down"
						tooltip={window.language['playlist.mediaarea.tipdown']}
						disabled={mediaareaRows.length < 1}
						onClick={(event) => {
							onDown(event, 'mediaArea', { type: 'down' });
						}}>
					</Button>
					<Button icon="caret-up"
						tooltip={window.language['playlist.mediaarea.tiptop']}
						disabled={mediaareaRows.length < 1}
						onClick={(event) => {
							onTop(event, 'mediaArea', { type: 'top' });
						}}>
					</Button>
					<Button icon="caret-down"
						tooltip={window.language['playlist.mediaarea.tipbottom']}
						disabled={mediaareaRows.length < 1}
						onClick={(event) => {
							onBottom(event, 'mediaArea', { type: 'bottom' });
						}}>
					</Button>
					<Button icon="edit"
						tooltip={window.language['playlist.mediaarea.batchedit']}
						disabled={mediaareaRows.length < 2}
						onClick={(event) => {
							onBatchEdit(event, 'mediaArea', { type: 'edit' });
						}}>
					</Button>
					<Button icon="close"
						tooltip={window.language['playlist.mediaarea.tipdelete']}
						disabled={!mediaareaRows.length}
						onClick={(event) => {
							onDelete(event, 'mediaArea', { type: 'delete' });
						}}>
					</Button>
					<Button icon="delete"
						tooltip={window.language['playlist.mediaarea.tipclear']}
						onClick={(event) => {
							onClear(event, 'mediaArea', { type: 'clear' });
						}}>
					</Button>
				</Button.Group>

			</Toolbar>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Playlist/MediaTools.js